import  { useRef } from 'react';
import { motion, useScroll, useTransform } from 'framer-motion';

interface ParallaxSectionProps {
  image: string;
  title: string;
  subtitle: string;
  reversed?: boolean;
}

const ParallaxSection = ({ image, title, subtitle, reversed = false }: ParallaxSectionProps) => {
  const ref = useRef<HTMLDivElement>(null);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start end", "end start"]
  });

  const y = useTransform(
    scrollYProgress,
    [0, 1],
    reversed ? ['-10%', '10%'] : ['10%', '-10%']
  );

  const textY = useTransform(
    scrollYProgress,
    [0, 1],
    reversed ? ['10%', '-10%'] : ['-10%', '10%']
  );

  const opacity = useTransform(
    scrollYProgress,
    [0, 0.3, 0.7, 1],
    [0, 1, 1, 0]
  );

  return (
    <div ref={ref} className="relative h-96 overflow-hidden">
      <motion.div
        className="absolute inset-0"
        style={{ y, opacity }}
      >
        <div className="absolute inset-0 bg-black bg-opacity-50 z-10"></div>
        <img
          src={image}
          alt={title}
          className="w-full h-full object-cover"
        />
      </motion.div>
      <motion.div
        className="absolute inset-0 flex flex-col items-center justify-center z-20 text-white px-4"
        style={{ y: textY, opacity }}
      >
        <h2 className="font-serif text-4xl md:text-5xl mb-4 text-center">{title}</h2>
        <p className="text-xl max-w-lg text-center">{subtitle}</p>
      </motion.div>
    </div>
  );
};

export default ParallaxSection;
 